export default "__VITE_ASSET__BFJyT8a3__"